import { connect } from 'react-redux';
import { TWPaymentOptions } from './PaymentOptions';
import { createSessionOrder as createSessionOrderAction, createSubscriptionOrder as createSubscriptionOrderAction } from '../../../state/actions';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var sessionResource = ownProps.session ? state.assets.resources[ownProps.session.id] : null;
  var availablePlans = (sessionResource ? sessionResource.plans : []).filter(function (p) {
    return !!p.active;
  });
  var sessionAccess = ownProps.session ? state.session.sessionAccess[ownProps.session.id] : null;
  return {
    availablePlans: availablePlans,
    sessionAccess: sessionAccess
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    createSessionOrder: function createSessionOrder(dto) {
      return dispatch(createSessionOrderAction(dto, {
        shouldRedirect: true
      }));
    },
    createSubscriptionOrder: function createSubscriptionOrder(planId, includedAssets) {
      return dispatch(createSubscriptionOrderAction({
        planId: planId,
        includedAssets: includedAssets,
        options: {
          shouldRedirect: true
        }
      }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TWPaymentOptions);